if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"packages_confetti_src_components_Popper_Popper_tsx":1,"packages_confetti_src_components_EmojiPicker_EmojiPicker_tsx-node_modules_babel_runtime_helpe-4689aa":1,"ui_components_questions_QuestionPageView_tsx-ui_components_header_constellationHeader_scss-ui-406dfe":1,"ui_components_discussion_DiscussionBreakSectionView_tsx-ui_components_discussion_discussionQu-e7ac86":1,"ui_components_sections_SectionFourView_tsx-ui_components_header_constellationHeader_scss-ui_c-9aa3eb":1,"ui_components_join_JoinSession_tsx-ui_components_header_constellationHeader_scss-ui_component-a09b68":1,"ui_components_join_Waiting_tsx-ui_components_waitingRoom_waitingRoom_scss":1,"ui_components_closing_ClosingFeedback_tsx-ui_components_header_constellationHeader_scss-ui_co-cbf925":1,"ui_components_feedback_FeedbackView_tsx":1,"ui_components_insights_SessionInsights_tsx-ui_components_insights_InsightDrawer_scss-ui_compo-e4389f":1,"ui_components_welcome_Welcome_tsx":1,"ui_components_creation_CreateSession_tsx":1,"ui_components_creation_CreateSessionSuccess_tsx-ui_components_waitingRoom_waitingRoom_scss":1,"ui_components_creation_Attributes_tsx":1,"ui_components_settings_AttributesSettings_tsx":1,"ui_components_debug_DebugIndex_tsx-ui_components_header_constellationHeader_scss-ui_component-c57fa5":1,"ui_components_debug_DebugQuestionPage_tsx-ui_stores_sessionStore_ts":1,"ui_components_debug_DebugRankingPage_tsx-ui_stores_sessionStore_ts-ui_components_debug_debugQ-3d71ce":1,"ui_components_debug_DebugDiscussionPage_tsx-ui_components_debug_debugQuestionPage_scss":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr